import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Lessons } from './pages/Lessons';
import { LessonDetail } from './pages/LessonDetail';
import { MapExplorer } from './pages/MapExplorer';
import { Games } from './pages/Games';
import { Awards } from './pages/Awards';
import { Chat } from './pages/Chat';
import { PublicLibrary } from './pages/PublicLibrary';

function App() {
  const location = useLocation();

  return (
    <div className="relative min-h-screen flex flex-col overflow-x-hidden">
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
        <span className="kids-float kids-float-1" />
        <span className="kids-float kids-float-2" />
        <span className="kids-float kids-float-3" />
        <span className="kids-float kids-float-4" />
      </div>

      <Header />

      <main className="relative z-10 flex-1 pt-[88px] md:pt-[96px] pb-28 md:pb-0">
        <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/lessons" element={<Lessons />} />
            <Route path="/lessons/:id" element={<LessonDetail />} />
            <Route path="/map" element={<MapExplorer />} />
            <Route path="/games" element={<Games />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/library" element={<PublicLibrary />} />
          </Routes>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}

export default App;
